import billingApiAgent from '../../services/api/billingApiAgent';
import CompanyFieldStore from './companyFieldStore';

/**
 * The composition root of a company field store: the one place it meets the register lookup
 * (`GET Companies?q=`) and the real clock. Every form with a company field gets a store of its own from
 * here, handed to the form's store by that store's own composition root.
 */
export const createCompanyFieldStore = (): CompanyFieldStore =>
  new CompanyFieldStore({
    lookup: (query) => billingApiAgent.Companies.lookup(query),
    wait: (milliseconds) => new Promise((resolve) => setTimeout(resolve, milliseconds)),
  });
